<template lang="html">
  <div class="invite">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>

    <img :src="`${pagebase}/static/img/assistances/back2.png`" alt="" class="backInvite">
    <div class="inviteCon">
      <div class="swiperMod">
        <div class="swiper-container swiperCon swiper-no-swiping" v-show="helpingList.length">
          <div class="swiper-wrapper">
            <div class="swiper-slide swiperSlide" v-for="(a, index) in helpingList" :key="index">
              <div class="friendPhone">
                <p>助力好友</p>
                <p class="phone">{{a.phone.slice(0,3) + '****' + a.phone.slice(7,12)}}</p>
              </div>
              <div>{{ a.create_time }}</div>
            </div>
          </div>
        </div>
        
        <div class="noPeople" v-show="helpingList.length == 0">
          好惨哦，没有一个助力呢，快去邀请吧
        </div>
      </div>
      
      <div class="honoree" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back3.png` +')'}">
        <p>领取奖励者：</p>
        <span>{{honoree}}</span>
      </div>

      <div class="wealNo1" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back4.png` +')'}">
        <div class="wealNum">
          <p>还差</p>
          <p class="people" v-if="1 - helpingList.length > 0">{{1- helpingList.length}}</p>
          <p class="people" v-else>{{0}}</p>
          <p>人</p>
        </div>

        <div class="receiveAward" v-if="prize1">
          <div>已领取</div>
        </div>
        <div class="wealBtn" v-else>
          <div v-if="1 - helpingList.length > 0" @click="goShare">去分享</div>
          <div v-else @click="emailShow = true, wealNum = 1">去领取</div>
        </div>
      </div>

      <div class="wealNo2" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back5.png` +')'}">
        <div class="wealNum">
          <p>还差</p>
          <p class="people" v-if="3 - helpingList.length > 0">{{3 - helpingList.length}}</p>
          <p class="people" v-else>{{0}}</p>
          <p>人</p>
        </div>

        <div class="receiveAward" v-if="prize2">
          <div>已领取</div>
        </div>
        <div class="wealBtn" v-else>
          <div v-if="3 - helpingList.length > 0" @click="goShare">去分享</div>
          <div v-else @click="emailShow = true, wealNum = 2">去领取</div>
        </div>
      </div>

      <div class="wealNo3" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back6.png` +')'}">
        <div class="wealNum">
          <p>还差</p>
          <p class="people" v-if="5 - helpingList.length > 0">{{5 - helpingList.length}}</p>
          <p class="people" v-else>{{0}}</p>
          <p>人</p>
        </div>

        <div class="receiveAward" v-if="prize3">
          <div>已领取</div>
        </div>
        <div class="wealBtn" v-else>
          <div v-if="5 - helpingList.length > 0" @click="goShare">去分享</div>
          <div v-else @click="locationShow = true, wealNum = 3">去领取</div>
        </div>
      </div>

      <img :src="`${pagebase}/static/img/assistances/back7.png`" alt="" class="inviteImg">

      <div class="conBtn">
        <div class="liveStreamingBtn" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button1.png` +')'}" @click="golive">
          观看直播
        </div>
        <div class="giftBtn" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/button2.png` +')'}" @click="goShare">
          <img :src="`${pagebase}/static/img/assistance/icon.png`" alt="">
          免费领实物礼品
        </div>
      </div>
    </div>

    <!-- 填邮箱 -->
    <div class="emailCard" v-show="emailShow" @click.self="emailShow = false">
      <div class="emailCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back10.png` +')'}">
        <input type="email" class="emailInput" placeholder="写输入您接收资料的邮箱" name="emailInput" v-model="email">

        <div class="confirmBtn" @click.stop="confirmEmail">
          确定
        </div>
      </div>
    </div>

    <!-- 填地址 -->
    <div class="locationCard" v-show="locationShow" @click.self="locationShow = false">
      <div class="locationCon" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistances/back11.png` +')'}">
        <div class="locationTxt">
          <p>请输入您详细的收货地址</p>
          <textarea placeholder="（例如广东省深圳市南山区深圳湾科技园8号楼802室）不能修改哦" v-model='location'></textarea>
        </div>

        <div class="confirmBtn" @click.stop="confirmLocation">
          确定
        </div>
      </div>
    </div>

    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    pagebase
  } from '@/utils/http.js';
  import Swiper from 'swiper/swiper-bundle.min.js'
  import 'swiper/swiper-bundle.min.css'

  import utils from '@/utils/utils.js';
  import '@/utils/rem'
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare'

  export default {
    data() {
      return {
        pagebase: pagebase,
        helpingList: [],
        emailShow: false,
        email: '',
        locationShow: false,
        location: '',
        wealNum: 0,
        activityUrl: '',
        informerShow: 0,
        honoree: '',
        
        prize1:0,
        prize2:0,
        prize3:0,
      }
    },

    mounted() {      
      this.honoree = Cookies.get('phone');
      this.getHelpingList();
      this.gitActivityInfo();
      
      this.getLiveUrl();
      
      new WxShare().share({
        title: '0元领超大半导体图谱桌垫',
        desc: '2000+电子工程师已领取',
        link: pagebase + '/#/assistances?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId,
        imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
      });
    },

    methods: {
      getOneSwiper() {
        new Swiper(".swiper-container", {
          autoplay: true,
          delay: 1000,
          loop: true,
          direction: "vertical",
          noSwiping: true,
        });
      },

      gitActivityInfo() {
        this.$http({
          url: '/member/activityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            reg_channel: Cookies.get('reg_channel'),
            activity_reg_id: Cookies.get('aid'),
            type: 0,
            live_activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.prize1 = res.data.gift[0].is_get;
            this.prize2 = res.data.gift[1].is_get;
            this.prize3 = res.data.gift[2].is_get;
            this.getOneSwiper();
          }
        })
      },

      // 助力列表
      getHelpingList() {
        this.$http({
          url: '/member/getHelpingList',
          method: 'get',
          params: {
            activity_reg_id: Cookies.get('aid'),
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.helpingList = res.data;
          }
        })
      },

      // 跳转直播间
      getLiveUrl() {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityUrl = res.data.live_url;
            if (Cookies.get('uid') && Cookies.get('token')) {
              this.getInfo = true;
            } else {
              this.getInfo = false;
            }
          }
        })
      },
      
      golive(){
        window.location.href = 'https://appZtx88lAc9991.h5.xiaoeknow.com/v2/course/alive/l_6385af54e4b0fc5d120c2807?app_id=appZtx88lAc9991&alive_mode=0&pro_id=&type=2';
      },

      // 分享
      goShare() {
        this.$router.push({
          path: '/assistancesShare',
          query:{
            activityId: this.$route.query.activityId,
          }
        })
      },

      // 确认邮箱
      confirmEmail() {
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (mailReg.test(this.email)) {
          this.$http({
            url: '/member/getPrize',
            method: 'post',
            params: {
              uid: Cookies.get('uid'),
              token: Cookies.get('token'),
              reg_channel: Cookies.get('reg_channel'),
              activity_reg_id: Cookies.get('aid'),
              type: this.wealNum,
              address: this.email,
              live_activity_id: this.$route.query.activityId,
            },
          }).then((res) => {
            if (res.code >= 0) {
              utils.showMessage(res.msg)
              this.emailShow = false;
              this.gitActivityInfo();
            } else {
              utils.showMessage(res.msg)
              this.emailShow = false;
            }
          })
        } else {
          utils.showMessage('请输入正确的邮箱格式')
        }
      },

      // 确认地址
      confirmLocation() {
        if (this.location) {
          this.$http({
            url: '/member/getPrize',
            method: 'post',
            params: {
              uid: Cookies.get('uid'),
              token: Cookies.get('token'),
              reg_channel: Cookies.get('reg_channel'),
              activity_reg_id: Cookies.get('aid'),
              type: this.wealNum,
              address: this.location,
              live_activity_id: this.$route.query.activityId,
            },
          }).then((res) => {
            if (res.code >= 0) {
              utils.showMessage(res.msg)
              this.locationShow = false;
              this.gitActivityInfo();
            } else {
              utils.showMessage(res.msg)
              this.locationShow = false;
            }
          })
        } else {
          utils.showMessage('请输入您的详细地址')
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .invite {
    position: relative;
    width: 100%;
    height: 240rem;
    background: linear-gradient(#000824, #011448);
  }

  .informerBtn {
    position: absolute;
    top: 2rem;
    right: 0;
    display: flex;
    justify-content: flex-end;
  }

  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #06314e;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .backInvite {
    width: 100%;
  }

  .inviteCon {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 42.65rem;
    left: 0;
  }
  
  .swiperMod {
    box-sizing: border-box;
    padding: 0 1.5rem;
    margin-top: 1rem;
  }

  .swiperCon {
    width: 100%;
    height: 3.25rem;
    border-radius: 3.25rem;
    background: linear-gradient(rgba(0, 240, 255, 1), rgba(0, 120, 255, 0.3));
  }

  .swiperSlide {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    color: #FFFFFF;
    padding: 0 1.5rem;
  }

  .friendPhone {
    display: flex;
    align-items: center;
  }

  .phone {
    margin-left: .55rem;
  }

  .noPeople {
    box-sizing: border-box;
    width: 100%;
    height: 3.25rem;
    border-radius: 3.25rem;
    background: linear-gradient(rgba(0, 240, 255, 1), rgba(0, 120, 255, 0.3));
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1.5rem;
    font-size: 1.4rem;
    color: #FFFFFF;
  }
  
  .honoree {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 100% 100%;
    height: 6.2rem;
  }
  
  .honoree p {
    color: #FFFFFF;
    font-size: 1.5rem;
  }
  
  .honoree span {
    color: #FFFFFF;
    font-size: 1.95rem;
  }

  .wealNo1 {
    box-sizing: border-box;
    width: 100%;
    height: 35rem;
    background-size: 100% 100%;
    margin-top: -1rem;
  }

  .wealNo1 > .wealNum {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 7.5rem;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .people {
    padding: 0 .5rem;
    color: #02deff;
  }

  .wealCard {
    display: flex;
    justify-content: space-between;
    margin-top: .8rem;
  }

  .wealCon1 {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .wealCon1 img {
    width: 6rem;
    height: 6rem;
  }

  .wealCon1 p {
    font-size: 1.4rem;
    font-weight: 600;
    color: #642207;
    margin-top: .5rem;
  }

  .receiveAward {
    margin-top: 17rem;
    display: flex;
    justify-content: center;
  }

  .receiveAward div {
    width: 20.8rem;
    height: 3.8rem;
    border-radius: 3.8rem;
    background: linear-gradient(170deg, rgba(255, 206, 146, 0.5), rgba(199, 71, 42, 0.5));
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: #C68A70;
  }

  .wealBtn {
    margin-top: 17rem;
    display: flex;
    justify-content: center;
  }

  .wealBtn div {
    width: 20.8rem;
    height: 3.8rem;
    border-radius: 3.8rem;
    background: linear-gradient(170deg, #FFCE92, #C7472A);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: #3F1504;
  }

  .wealNo2 {
    width: 100%;
    height: 35rem;
    background-size: 100% 100%;
  }
  
  .wealNo2 > .wealNum {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 6.5rem;
    font-size: 1.6rem;
    color: #FFFFFF;
  }

  .wealCon2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .wealCon2 img {
    width: 6rem;
    height: 6rem;
  }

  .wealCon2 p {
    font-size: 1.4rem;
    font-weight: 600;
    color: #642207;
    margin-top: 1rem;
  }

  .wealCon2 span {
    font-size: 1.1rem;
    color: #642207;
    font-weight: 500;
  }

  .wealNo3 {
    width: 100%;
    height: 40rem;
    background-size: 100% 100%;
  }
  
  .wealNo3 > .wealNum {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 7.2rem;
    font-size: 1.6rem;
    color: #FFFFFF;
  }
  
  .wealNo3 > .receiveAward {
    margin-top: 22rem;
    display: flex;
    justify-content: center;
  }
  
  .wealNo3 > .wealBtn {
    margin-top: 22rem;
    display: flex;
    justify-content: center;
  }

  .wealCon3 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wealCon3 img {
    width: 31.65rem;
    height: 19.25rem;
    margin-top: 1.6rem;
  }

  .wealCon3 div {
    font-size: 1.4rem;
    color: #642207;
    font-weight: 600;
    margin-top: .8rem;
    text-align: center;
  }

  .inviteImg {
    width: 100%;
  }

  .conBtn {
    box-sizing: border-box;
    background-color: #02185a;
    display: flex;
    justify-content: space-between;
    margin-top: -1rem;
    padding: 2rem 1.5rem;
  }

  .liveStreamingBtn {
    position: relative;
    width: 43%;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #642207;
  }

  .giftBtn {
    width: 53%;
    height: 5.5rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: .4rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: #642207;
  }

  .giftBtn img {
    width: 1.75rem;
    margin-right: .4rem;
  }

  /* 邮件 */
  .emailCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .emailCon {
    width: 31rem;
    height: 35.8rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .emailInput {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    border: none;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 2.5rem;
    font-size: 1.5rem;
    color: #642207;
    outline: none;
    margin-bottom: 2.8rem;
  }

  .emailInput[name="emailInput"]::-webkit-input-placeholder {
    color: #642207;
  }

  .confirmBtn {
    width: 100%;
    height: 4.7rem;
    border-radius: 4.7rem;
    background: linear-gradient(170deg, #FFDB9E, #FF9F55);
    margin-bottom: 3.65rem;
    font-size: 1.8rem;
    font-weight: 600;
    color: #642207;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 地址 */
  .locationCard {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .locationCon {
    width: 31rem;
    height: 43.3rem;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 1.6rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .locationTxt {
    margin-bottom: 2rem;
    width: 100%;
    height: 13.85rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    box-sizing: border-box;
    padding: 1.2rem 1.3rem;
  }

  .locationTxt p {
    font-size: 1.5rem;
    color: #642207;
    font-weight: 600;
  }

  .locationTxt textarea {
    margin-top: .95rem;
    width: 25rem;
    height: 8.5rem;
    padding: 0;
    border: none;
    resize: none;
    outline: none;
    font-size: 1.7rem;
  }

  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }

  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }
</style>
